import { MenuIndex } from "./model/mainMenuIndex";
import { Menu } from "./model/menu";

export const pdfFile = "tlc_0117";

export const list = [
    new MenuIndex("Medical Solution", 4, [
      new Menu("TLC Medical Solution", 5),
      new Menu("TLC Kiosk", 6),
    ]),
    new MenuIndex("Doctors MTM", 8, [
      new Menu("질환맞춤식단", -1, [
        new Menu("당뇨식단", 12),
        new Menu("암환자식단", 23),
        new Menu("신장질환식단", 32),
        new Menu("저요오드식단", 43),
      ]),
      new Menu("회복식단", -1, [
        new Menu("질환회복식단", 49),
        new Menu("위장관 회복영양식단", 59),
        new Menu("임플란트식단", 67),
      ]),
      new Menu("건강균형식단", -1, [
        new Menu("일반식단", 79),
        new Menu("당조절식단", 90),
        new Menu("염분조절식단", 96),
        new Menu("저탄고지식단", 98),
      ]),
      new Menu("칼로리식단", -1, [
        new Menu("300kcal식단", 102),
        new Menu("500kcal식단", 114),
      ]),
      new Menu("영유아식", -1, [
        new Menu("이유식", 116),
        new Menu("유아식", 128),
      ]),
      new Menu("보충식품", -1, [new Menu("뉴케어", 139), new Menu("기타", 147)]),
    ]),
    new MenuIndex("Doctors MTE", 150, [new Menu("TLC X YAFIT", 154)]),
    new MenuIndex("Doctors MTS", 158, [
      new Menu("영양성분별", -1, [
        new Menu("비타민", 162),
        new Menu("미네랄", 164),
        new Menu("오메가3", 166),
        new Menu("유산균", 167),
        new Menu("항산화/항노화", 168),
      ]),
      new Menu("대상별", -1, [
        new Menu("남성건강", 169),
        new Menu("여성건강", 170),
        new Menu("소아청소년", 171),
        new Menu("기타", 172),
      ]),
    ]),
    new MenuIndex("Doctors Counseling", 176, [
      new Menu("유아동", 180),
      new Menu("청소년", 182),
      new Menu("성인", 183),
      new Menu("검사", 184),
      new Menu("치료&코칭", 186),
    ]),
    new MenuIndex("Doctors Care", 188, [
      new Menu("TLC X Samsung", 193),
      new Menu("Doctors Care App", 192),
    ]),
  ];